const privateStyles = () => ({
  minHeight: '42px !important',
  lineHeight: '38px !important',
  fontSize: '16px !important',
  borderRadius: '5px !important',
  fontWeight: '400 !important',
  textTransform: 'none !important',
  boxShadow: 'none !important',
  padding: '0 15px !important',
  minWidth: '140px !important',
  border: '1px solid transparent !important',

  '&.MuiButton-contained': {
    color: '#fff !important',
    background: '#2845D2',

    '&:hover': {
      color: '#fff !important',
      background: '#1431c2',
      borderColor: '#1431c2 !important',
    },

    '&.dn-button-error': {
      background: '#FF0000 !important',
      borderColor: '#FF0000 !important',
      color: '#fff !important',

      '&:hover': {
        background: '#B10000 !important',
        borderColor: '#B10000 !important',
      },

      '&.Mui-disabled': {
        background: '#E5E5E5 !important',
        border: '1px solid rgba(0, 0, 0, 0.05) !important',
        color: '#bbbbbb !important',

        svg: {
          color: '#bbbbbb !important',
        },
      },
    },

    '&.dn-button-inverted': {
      color: '#fff !important',
      backgroundColor: '#1431c2 !important',
      border: '1px solid #1431c2 !important',

      '&:hover': {
        backgroundColor: '#2845D2 !important',
        border: '1px solid #2845D2 !important',
        color: '#fff !important',
      },
    },
  },

  '&.MuiButton-outlined': {
    background: '#fff !important',
    borderColor: 'rgba(40, 69, 210, 0.2) !important',
    color: '#4B4B4B !important',

    '&:hover': {
      background: 'rgba(40, 69, 210, 0.05) !important',
    },

    '.MuiSvgIcon-root': {
      color: '#2845D2 !important',
      marginRight: '5px !important',
    },
  },

  '&.Mui-disabled': {
    background: '#E5E5E5 !important',
    border: '1px solid rgba(0, 0, 0, 0.05) !important',
    color: '#bbbbbb !important',

    svg: {
      color: '#bbbbbb !important',
    },
  },
  '&.MuiButton-sizeSmall': {
    margin: '0',
    height: '36px',
    minWidth: 'auto !important',
    minHeight: 'auto !important',
    fontSize: '12px !important',
    lineHeight: '14px !important',
    '.MuiSvgIcon-root': {
      marginRight: '5px',
      fontSize: '18px !important',
    },
    '&.MuiButton-contained': {
      fontWeight: '700 !important',
    },
  },
});

export { privateStyles };
